import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field, FormSpy } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createDecorator from 'final-form-calculate';
import { FormControl, InputGroup } from 'react-bootstrap';
import _ from 'lodash';
import currencyConversion from '../../utils/currencyConversion';

import './ScheduleD.less';
import ScheduleDCreditorFields from './ScheduleDCreditorFields';
import PagedFieldArray from '../common/PagedFieldArray';

const creditorToForm = (creditor) => ({
  ...creditor,
  claim_amount_cents: currencyConversion.toDollarsOrStr(creditor.claim_amount_cents),
  collateral_amount_cents: currencyConversion.toDollarsOrStr(creditor.collateral_amount_cents),
  is_creditor_an_insider: creditor.is_creditor_an_insider
    ? 'yes'
    : creditor.is_creditor_an_insider === false
    ? 'no'
    : '',
  is_anyone_else_liable: creditor.is_anyone_else_liable ? 'yes' : creditor.is_anyone_else_liable === false ? 'no' : '',
  has_multiple_creditor_interest: creditor.has_multiple_creditor_interest ? 'yes' : 'no',
  has_already_specified_creditor_priority: creditor.has_already_specified_creditor_priority ? 'yes' : 'no',
});

const confirm_remove_claim = () => confirm('Remove this creditor?');
const confirm_move_claim = () => confirm('Move / renumber this creditor?');

const NumberField = ({ input, ...rest }) => (
  <InputGroup>
    <InputGroup.Addon>$</InputGroup.Addon>
    <FormControl bsSize="small" {...input} {...rest} />
  </InputGroup>
);

class ScheduleDForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    isDraft: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => null,
  };

  render() {
    const { onSubmit } = this.props;

    const calculator = createDecorator({
      field: /\.claim_amount_cents/,
      updates: {
        total_claims_amount_cents: (fieldValue, allValues) =>
          currencyConversion.toDollars(
            (allValues.creditors || []).reduce(
              (total, creditor) => total + currencyConversion.toCents(creditor.claim_amount_cents),
              0
            )
          ),
      },
    });

    const initialValue = {
      creditors: _.cloneDeep(_.get(this.props.schedule, 'data.creditors', []).map(creditorToForm)),
      total_claims_amount_cents: this.props.schedule.data
        ? currencyConversion.toDollars(this.props.schedule.data.total_claims_amount_cents)
        : 0,
    };

    return (
      <Form
        initialValues={initialValue}
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators,
        }}
        subscription={{}} // optimization for large number of creditors
        decorators={[calculator]}
        render={({ handleSubmit, form }) => (
          <form onSubmit={handleSubmit} id="parser-schedule-d-form">
            {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
            <table id="secured-creditors">
              <thead>
                <tr>
                  <th colSpan={2}>Creditors Who Have Secured Claims</th>
                </tr>
              </thead>
              <tbody>
                <PagedFieldArray
                  name="creditors"
                  item={({ fields, name, index }) => (
                    <tr key={name} className={index !== 0 ? 'additional_creditor' : ''}>
                      <td>
                        <ScheduleDCreditorFields
                          index={index}
                          creditor={name}
                          onRemove={() => confirm_remove_claim() && fields.remove(index)}
                          onMoveUp={index > 0 && (() => confirm_move_claim() && fields.swap(index, index - 1))}
                          onMoveDown={
                            index < fields.length - 1 && (() => confirm_move_claim() && fields.swap(index, index + 1))
                          }
                          onAdd={() => {
                            const creditors = [...form.getState().values.creditors];
                            creditors.splice(index, 0, creditorToForm({}));
                            form.change('creditors', creditors);
                            // for some reason this leads to uneditable form fields
                            // fields.insert(index, creditorToForm({}))
                          }}
                        />
                      </td>
                    </tr>
                  )}
                  after={() => (
                    <div className="editable">
                      <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => form.mutators.push('creditors', creditorToForm({}))}
                      >
                        + Add creditor
                      </button>
                    </div>
                  )}
                />
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <span className="label">
                              Total of the dollar amounts from Part 1, Column A, including the amounts from the
                              Additional Page, if any.
                            </span>
                          </td>
                          <td className="money total">
                            <Field
                              name="total_claims_amount_cents"
                              component={NumberField}
                              id="claim-total"
                              size={10}
                              type="text"
                              step={0.01}
                              precision={2}
                              placeholder=""
                              readOnly
                            />
                          </td>
                          <td className="money" />
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tfoot>
            </table>
            <FormSpy
              subscription={{
                submitting: true,
                pristine: true,
                values: true, // needed for `pristine` to properly work (in some? cases)
              }}
            >
              {({ submitting, pristine }) => (
                <div className="buttons">
                  <button
                    type="submit"
                    disabled={submitting || (pristine && !this.props.isDraft)}
                    className="btn btn-primary"
                  >
                    Submit Changes
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      if (
                        pristine ||
                        confirm(
                          'You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!'
                        )
                      )
                        this.props.onCancel();
                    }}
                    disabled={submitting}
                    className={`btn btn-link ${pristine ? '' : 'cancel-link'}`}
                  >
                    {pristine ? 'Cancel Editing' : 'Discard Changes'}
                  </button>
                </div>
              )}
            </FormSpy>
          </form>
        )}
      />
    );
  }
}

ScheduleDForm.propTypes = {
  schedule: PropTypes.any.isRequired,
};

export default ScheduleDForm;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_d/ScheduleDForm.jsx